import { lazy } from "react";
const LocationTracker = lazy(() => import("../pages/TestPages/LocationTracker/LocationTracker"));

const testRoutes = [
  {
    id: "loct54651",
    path: "/tests/location-tracker",
    element: <LocationTracker />,
  },
];

export default testRoutes;
